import React from 'react';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import BlockIcon from '@mui/icons-material/Block';
import { ConfirmDeleteChildrenProps } from './ConfirmDelete';
import { TranslatedText } from '@ianesthesie-kit/core';

type ConfirmDeleteIconsProps = {
  DeleteIcon?: typeof ClearIcon;
  CancelDeleteIcon?: typeof BlockIcon;
  ConfirmDeleteIcon?: typeof CheckIcon;
  iconButtonProps?: Omit<IconButtonProps, 'onClick'>;
} & ConfirmDeleteChildrenProps;

export function ConfirmDeleteIcons({
  confirm,
  onClick,
  onCancel,
  DeleteIcon = ClearIcon,
  CancelDeleteIcon = BlockIcon,
  ConfirmDeleteIcon = CheckIcon,
  iconButtonProps
}: ConfirmDeleteIconsProps) {
  return (
    <>
      {confirm && (
        <Tooltip title={<TranslatedText id="app.cancel" />}>
          <IconButton
            size="small"
            aria-label="Cancel delete"
            {...iconButtonProps}
            data-testid="cancelDeleteBtn"
            onClick={onCancel}
          >
            <CancelDeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={<TranslatedText id="app.delete" />}>
        <IconButton
          size="small"
          aria-label="Delete Confirm"
          {...iconButtonProps}
          data-testid="confirmDeleteBtn"
          onClick={onClick}
        >
          {confirm ? (
            <ConfirmDeleteIcon fontSize="small" />
          ) : (
            <DeleteIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </>
  );
}
